import { transformFilters } from '@lib/filtersToFormValues'

const getNormalizedValue = (isArrayKey: boolean, values: string[]) => {
  if (isArrayKey) {
    return values
  }

  return values.length > 1 ? values : values[0]
}

export const useInitialValues = (searchParams: URLSearchParams) => {
  const normalizedParams: Record<string, unknown> = {}

  for (const key of new Set(searchParams.keys())) {
    const values = searchParams.getAll(key)
    const isArrayKey = key.endsWith('[]')
    const normalizedKey = isArrayKey ? key.slice(0, -2) : key

    normalizedParams[normalizedKey] = getNormalizedValue(isArrayKey, values)
  }

  const transformed = transformFilters(normalizedParams)

  return { queryParams: transformed }
}
